<div class="newField-select-config">

  <div style="display: flex; align-items: center; gap: 4px; flex-wrap: wrap;">
    <button [ngClass]="configMode == 'basic' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'basic'">
      <span>{{('cau_hinh_co_ban') | translate}}</span>
    </button>
  
    <button [ngClass]="configMode == 'advanced' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'advanced'">
      <span>{{('cau_hinh_nang_cao') | translate}}</span>
    </button>
  </div>

    <!-- Cấu hình cơ bản -->
  <ng-container *ngIf="configMode == 'basic'">
    <div style="margin-top: 10px">
      <!-- Chữ nền -->
      <div class="container-font">
        <h3 class="text-center mb-1"><strong>{{'chu_nen' | translate}}</strong></h3>
        <div class="config-text" style="width: 100%">
          <mat-form-field style="width: 100%">
            <mat-label> {{'noi_dung' | translate}}</mat-label>
            <textarea matInput
              [ngModel]="staticdata['placeholder_' + functionService.selectedLanguageCode] | vhLanguage : 'content' : objectChoosing.component"
              (ngModelChange)="staticdata['placeholder_' + functionService.selectedLanguageCode] = $event"
              (blur)="updateStaticData();"></textarea>
          </mat-form-field>
        </div>
        <app-text-format-config [objectChoosing]="objectChoosing" [isHideTextAlign]="true" [device]="device"
          [class]="class" [config]="config" [staticdata]="staticdata"
          [textContentClass]="class['select__input--placeholder']"
          [textWrapperClass]="class['select__input--placeholder']">
        </app-text-format-config>
        <!-- Khoảng cách chữ -->
        <app-letter-spacing-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
          [classLetterSpacing]="class['select__input--placeholder']" (updateClass)="updateClass()">
        </app-letter-spacing-config>
      </div>

      <!-- Chữ đã chọn -->
      <div class="container-font">
        <h3 class="text-center mb-1"><strong>{{'chu_da_chon' | translate}}</strong></h3>
        <app-text-format-config [objectChoosing]="objectChoosing" [isHideTextAlign]="true" [device]="device"
          [class]="class" [config]="config" [staticdata]="staticdata"
          [textContentClass]="class['select__input']" [textWrapperClass]="class['select__input']">
        </app-text-format-config>
        <!-- Khoảng cách chữ -->
        <app-letter-spacing-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
          [classLetterSpacing]="class['select__input']" (updateClass)="updateClass()">
        </app-letter-spacing-config>
      </div>

      <!-- Màu nền -->
      <div>
        <h3 class="text-center mb-1"><strong>{{'mau_nen' | translate}}</strong></h3>
        <div class="d-flex justify-content-between align-items-center">
          <span class="title w-50">{{'mau_nen' | translate}}</span>
          <input class="input-color w-50" type="button" [cpOKButton]="true"
            [(colorPicker)]="class['select__boundary']['background-color']"
            [style.background]="class['select__boundary']['background-color']"
            (colorPickerClose)="updateClass()" [cpWidth]="'230px'"
            [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength" [cpAddColorButton]="true"
            [cpAddColorButtonText]="'them_mau' | translate" [cpPresetLabel]="'bang_mau_mau' | translate"
            [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate"
            [cpPresetColors]="themeService.themeColors"
            (cpPresetColorsChange)="themeService.presetColorsChange($event)" />
        </div>
      </div>
    </div>
  </ng-container>


  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate }}</span>
  </div>
  <ng-container *ngIf="!isViewAll && configMode == 'advanced'">
    <ul nz-menu nzMode="inline">
      <!-- HIỂN THỊ -->
      <li nz-submenu nzTitle="{{'hien_thi'| translate}}" [(nzOpen)]="openMap.menu1"
        (nzOpenChange)="openHandler('menu1')">
          <!-- Lựa chọn hiển thị cho các thiết bị -->
          <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
          </app-hide-show-config>
      </li>
      <!-- CHỌN THÔNG SỐ -->
      <li nz-submenu nzTitle="{{'chon_thong_so' | translate}}" [(nzOpen)]="openMap.menu2"
        (nzOpenChange)="openHandler('menu2')">
        <mat-form-field *ngIf="staticdata.id_main_sector == 'snimei'" appearance="fill">
            <mat-label>{{'nhom_tra_cuu' | translate}}</mat-label>
            <mat-select [(ngModel)]="staticdata.lookup_group" (ngModelChange)="changeLookupGroup($event)">
              <mat-option *ngFor="let item of lookupGroupArray" [value]="item">
                {{item}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field style="width: 100%">
            <mat-label>{{'thong_so_san_pham' | translate}}</mat-label>
            <mat-select [(ngModel)]="staticdata.field_custom" (ngModelChange)="onChangeFieldCustom($event)"
              [disabled]="newFields.length == 0">
              <mat-option *ngFor="let item of newFields" [value]="item.field_custom">{{item?.field_lable ??
                item.field_custom}}</mat-option>
            </mat-select>
          </mat-form-field>
          <p class="line-normal" style="color: rgb(212, 78, 78);">
            {{
              'vui_long_vao_trang_admin_truong_du_lieu_tu_tao_tao_du_lieu_sau_do_quay_lai_day_chon_truong_du_lieu' | translate
            }}
          </p>
      </li>


      <!-- ----------------------------- Cấu hình ô chọn ------------------------------ -->
      <li nz-submenu [nzTitle]="'cau_hinh_o_chon' | translate" [(nzOpen)]="openMap.menu3"
        (nzOpenChange)="openHandler('menu3')">
        <ul nz-menu nzMode="inline">
          <!-- Thông số cơ bản -->
          <li class="pl-2" nz-submenu [nzTitle]="'thong_so_co_ban' | translate">
            <!-- Chữ nền -->
            <div class="container-font">
              <h3 class="text-center mb-1"><strong>{{'chu_nen' | translate}}</strong></h3>
              <div class="config-text" style="width: 100%">
                <mat-form-field style="width: 100%">
                  <mat-label> {{'noi_dung' | translate}}</mat-label>
                  <textarea matInput
                    [ngModel]="staticdata['placeholder_' + functionService.selectedLanguageCode] | vhLanguage : 'content' : objectChoosing.component"
                    (ngModelChange)="staticdata['placeholder_' + functionService.selectedLanguageCode] = $event"
                    (blur)="updateStaticData();"></textarea>
                </mat-form-field>
              </div>
              <app-text-format-config [objectChoosing]="objectChoosing" [isHideTextAlign]="true" [device]="device"
                [class]="class" [config]="config" [staticdata]="staticdata"
                [textContentClass]="class['select__input--placeholder']"
                [textWrapperClass]="class['select__input--placeholder']">
              </app-text-format-config>
              <!-- Khoảng cách chữ -->
              <app-letter-spacing-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
                [classLetterSpacing]="class['select__input--placeholder']" (updateClass)="updateClass()">
              </app-letter-spacing-config>
            </div>

            <!-- Chữ đã chọn -->
            <div class="container-font">
              <h3 class="text-center mb-1"><strong>{{'chu_da_chon' | translate}}</strong></h3>
              <app-text-format-config [objectChoosing]="objectChoosing" [isHideTextAlign]="true" [device]="device"
                [class]="class" [config]="config" [staticdata]="staticdata"
                [textContentClass]="class['select__input']" [textWrapperClass]="class['select__input']">
              </app-text-format-config>
              <!-- Khoảng cách chữ -->
              <app-letter-spacing-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
                [classLetterSpacing]="class['select__input']" (updateClass)="updateClass()">
              </app-letter-spacing-config>
            </div>

            <!-- Màu nền -->
            <div>
              <h3 class="text-center mb-1"><strong>{{'mau_nen' | translate}}</strong></h3>
              <div class="d-flex justify-content-between align-items-center">
                <span class="title w-50">{{'mau_nen' | translate}}</span>
                <input class="input-color w-50" type="button" [cpOKButton]="true"
                  [(colorPicker)]="class['select__boundary']['background-color']"
                  [style.background]="class['select__boundary']['background-color']"
                  (colorPickerClose)="updateClass()" [cpWidth]="'230px'"
                  [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength" [cpAddColorButton]="true"
                  [cpAddColorButtonText]="'them_mau' | translate" [cpPresetLabel]="'bang_mau_mau' | translate"
                  [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate"
                  [cpPresetColors]="themeService.themeColors"
                  (cpPresetColorsChange)="themeService.presetColorsChange($event)" />
              </div>
            </div>
          </li>

          <!-- Kiểu viền -->
          <li class="pl-2" nz-submenu nzTitle="{{'kieu_vien' | translate}}">
            <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
              [borderClass]="class['select__boundary']" [id_object]="objectChoosing._id">
            </app-borders-config>
          </li>

          <!-- Bo tròn -->
          <li class="pl-2" nz-submenu nzTitle="{{'bo_tron' | translate}}">
            <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
              [borderRadiusClass]="class['select__boundary']" [id_object]="objectChoosing._id">
            </app-borders-radius-config>
          </li>

          <!-- Biểu tượng -->
          <li class="pl-2" nz-submenu nzTitle="{{'bieu_tuong' | translate}}">
            <app-symbol-config [device]="device" [class]="class" [config]="config"
              [symbolClass]="class['select__icon']" [fontSizeIconClass]="class['select__icon']"
              [symbolConfig]="config['flex-direction']" [objectChoosing]="objectChoosing">
            </app-symbol-config>
          </li>
        </ul>
      </li>

      <!-- ----------------------------- Cấu hình ô chọn ------------------------------ -->
      <li nz-submenu [nzTitle]="'bieu_tuong' | translate" [(nzOpen)]="openMap.menu4"
        (nzOpenChange)="openHandler('menu4')">
        <app-symbol-config [device]="device" [class]="class" [config]="config"
          [symbolClass]="class['select__icon-inner']" [fontSizeIconClass]="class['select__icon']"
          [symbolConfig]="config['flex-direction']" [objectChoosing]="objectChoosing">
        </app-symbol-config>
      </li>

      <!-- ----------------------------- Cấu hình danh sách ------------------------------ -->
      <li nz-submenu [nzTitle]="'cau_hinh_danh_sach' | translate" [(nzOpen)]="openMap.menu5"
        (nzOpenChange)="openHandler('menu5')" (mouseover)="objectChoosing.isShow = true">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <p class="title m-0 line-normal" >{{'chon_nhieu' | translate}}</p>
          <nz-switch [(ngModel)]="staticdata.allow_multiple" (ngModelChange)="updateStaticData()"></nz-switch>
        </div>

        <div>
          <div class="slide-bar d-flex justify-content-between align-items-center ">
            <p class="m-0 title-border w-70 line-normal">{{'khoang_cach_toi_o_chon' | translate}}</p>
            <nz-input-number class="input-number" [nzMin]="0" [nzStep]="1"
              [ngModel]="class['select__dropdown-content']['top'] | vhnumber" (nzBlur)="updateClass()"
              (ngModelChange)="class['select__dropdown-content']['top'] = $event +'px'"></nz-input-number>
          </div>
          <div>
            <nz-slider [ngModel]="class['select__dropdown-content']['top'] | vhnumber" [nzMin]="0" [nzStep]="1"
              (nzOnAfterChange)="updateClass()"
              (ngModelChange)="class['select__dropdown-content']['top'] = $event +'px'"></nz-slider>
          </div>
        </div>

        <ul nz-menu nzMode="inline">
          <!-- Thông số cơ bản -->
          <li class="pl-2" nz-submenu [nzTitle]="'thong_so_co_ban' | translate">
            <!-- Chữ chưa chọn -->
            <div class="container-font">
              <h3 class="text-center mb-2"><strong>{{'chu_chua_chon' | translate}}</strong></h3>
              <ul nz-menu nzMode="inline">
                <!-- Định dạng chữ -->
                <li class="pl-2" nz-submenu [nzTitle]="'dinh_dang_chu' | translate">
                  <app-text-format-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
                    [config]="config" [staticdata]="staticdata" [textContentClass]="class['-select__label']"
                    [textWrapperClass]="class['-select__label']">
                  </app-text-format-config>

                  <!-- Khoảng cách chữ -->
                  <app-letter-spacing-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
                    [classLetterSpacing]="class['-select__label']" (updateClass)="updateClass()">
                  </app-letter-spacing-config>
                </li>

                <!-- Định dạng chữ -->
                <li class="pl-2" nz-submenu [nzTitle]="'mau_nen' | translate">
                  <div class="d-flex justify-content-between align-items-center">
                    <span class="title w-50">{{'mau_nen' | translate}}</span>
                    <input class="input-color w-50" type="button" [cpOKButton]="true"
                      [(colorPicker)]="class['-select__item']['background-color']"
                      [style.background]="class['-select__item']['background-color']"
                      (colorPickerClose)="updateClass()" [cpWidth]="'230px'"
                      [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength" [cpAddColorButton]="true"
                      [cpAddColorButtonText]="'them_mau' | translate" [cpPresetLabel]="'bang_mau_mau' | translate"
                      [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate"
                      [cpPresetColors]="themeService.themeColors"
                      (cpPresetColorsChange)="themeService.presetColorsChange($event)" />
                  </div>
                </li>

                <!-- Kiểu viền -->
                <li class="pl-2" nz-submenu [nzTitle]="'kieu_vien' | translate">
                  <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
                    [borderClass]="class['-select__item']" [id_object]="objectChoosing._id">
                  </app-borders-config>
                </li>

                <!-- Bo tròn -->
                <li class="pl-2" nz-submenu [nzTitle]="'bo_tron' | translate">
                  <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
                    [borderRadiusClass]="class['-select__item']" [id_object]="objectChoosing._id">
                  </app-borders-radius-config>
                </li>

                <li class="pl-2" nz-submenu [nzTitle]="'khoang_dem' | translate">
                  <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
                    [classPadding]="class['-select__item']" [paddingConfigs]="[
                          { type: 'top' },
                          { type: 'bottom' },
                          { type: 'left' },
                          { type: 'right' }
                          ]">
                  </app-padding-config>
                </li>
              </ul>
            </div>

            <!-- Chữ đã chọn -->
            <div class="container-font">
              <h3 class="text-center mb-2"><strong>{{'chu_da_chon' | translate}}</strong></h3>
              <ul nz-menu nzMode="inline">
                <!-- Định dạng chữ -->
                <li class="pl-2" nz-submenu [nzTitle]="'dinh_dang_chu' | translate">
                  <app-text-format-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
                    [config]="config" [staticdata]="staticdata" [textContentClass]="class['+select__label']"
                    [textWrapperClass]="class['+select__label']">
                  </app-text-format-config>

                  <!-- Khoảng cách chữ -->
                  <app-letter-spacing-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
                    [classLetterSpacing]="class['+select__label']" (updateClass)="updateClass()">
                  </app-letter-spacing-config>
                </li>

                <li class="pl-2" nz-submenu [nzTitle]="'mau_nen' | translate">
                  <div class="d-flex justify-content-between align-items-center">
                    <span class="title w-50">{{'mau_nen' | translate}}</span>
                    <input class="input-color w-50" type="button" [cpOKButton]="true"
                      [(colorPicker)]="class['+select__item']['background-color']"
                      [style.background]="class['+select__item']['background-color']"
                      (colorPickerClose)="updateClass()" [cpWidth]="'230px'"
                      [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength" [cpAddColorButton]="true"
                      [cpAddColorButtonText]="'them_mau' | translate" [cpPresetLabel]="'bang_mau_mau' | translate"
                      [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate"
                      [cpPresetColors]="themeService.themeColors"
                      (cpPresetColorsChange)="themeService.presetColorsChange($event)" />
                  </div>
                </li>

                <li class="pl-2" nz-submenu [nzTitle]="'kieu_vien' | translate">
                  <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
                    [borderClass]="class['+select__item']" [id_object]="objectChoosing._id">
                  </app-borders-config>
                </li>

                <li class="pl-2" nz-submenu [nzTitle]="'bo_tron' | translate">
                  <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
                    [borderRadiusClass]="class['+select__item']" [id_object]="objectChoosing._id">
                  </app-borders-radius-config>
                </li>

                <li class="pl-2" nz-submenu [nzTitle]="'khoang_dem' | translate">
                  <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
                    [classPadding]="class['+select__item']" [paddingConfigs]="[
                          { type: 'top' },
                          { type: 'bottom' },
                          { type: 'left' },
                          { type: 'right' }
                          ]">
                  </app-padding-config>
                </li>
              </ul>
            </div>
          </li>

          <li class="pl-2" nz-submenu [nzTitle]="'kieu_vien' | translate">
            <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
              [borderClass]="class['select__dropdown-content']" [id_object]="objectChoosing._id">
            </app-borders-config>
          </li>

          <li class="pl-2" nz-submenu [nzTitle]="'bo_tron' | translate">
            <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
              [borderRadiusClass]="class['select__dropdown-content']" [id_object]="objectChoosing._id">
            </app-borders-radius-config>
          </li>

          <li class="pl-2" nz-submenu [nzTitle]="'khoang_dem' | translate">
            <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
              [classPadding]="class['select__dropdown-content']" [paddingConfigs]="[
                    { type: 'top' },
                    { type: 'bottom' },
                    { type: 'left' },
                    { type: 'right' }
                    ]">
            </app-padding-config>
          </li>

          <li class="pl-2" nz-submenu [nzTitle]="'do_bong' | translate">
            <app-shadow-config [device]="device" [config]="config" [class]="class"
              [shadowClass]="class['select__dropdown-content']" [shadowConfig]="config['box-shadow']"
              [objectChoosing]="objectChoosing">
            </app-shadow-config>
          </li>

          <li *ngIf="staticdata.allow_multiple" class="pl-2" nz-submenu
            [nzTitle]="'cau_hinh_checkbox' | translate">
            <!-- Màu nền -->
            <div>
              <h3 class="text-center mb-1"><strong>{{'mau_nen' | translate}}</strong></h3>
              <div class="d-flex justify-content-between align-items-center">
                <span class="title w-50">{{'mau_nen' | translate}}</span>
                <input class="input-color w-50" type="button" [cpOKButton]="true"
                  [(colorPicker)]="class['select__checkbox']['accent-color']"
                  [style.background]="class['select__checkbox']['accent-color']"
                  (colorPickerClose)="updateClass()" [cpWidth]="'230px'"
                  [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength" [cpAddColorButton]="true"
                  [cpAddColorButtonText]="'them_mau' | translate" [cpPresetLabel]="'bang_mau_mau' | translate"
                  [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate"
                  [cpPresetColors]="themeService.themeColors"
                  (cpPresetColorsChange)="themeService.presetColorsChange($event)" />
              </div>
            </div>

            <div>
              <h3 class="text-center mb-1"><strong>{{'kich_thuoc' | translate}}</strong></h3>
              <div>
                <div class="slide-bar d-flex justify-content-between align-items-center">
                  <p class="m-0 title-border">{{'kich_thuoc' | translate}}</p>
                  <nz-input-number class="input-number" [nzMin]="0" [nzStep]="1"
                    [ngModel]="class['select__checkbox']['width'] | vhnumber"
                    (ngModelChange)="updateWidthAndHeight($event)" (nzBlur)="updateClass()"></nz-input-number>
                </div>
                <div>
                  <nz-slider [ngModel]="class['select__checkbox']['width'] | vhnumber" [nzMin]="0" [nzStep]="1"
                    (ngModelChange)="updateWidthAndHeight($event)" (nzOnAfterChange)="updateClass()"></nz-slider>
                </div>
              </div>
            </div>
          </li>
        </ul>

      </li>

      <!-- Ô tìm kiếm -->
      <li nz-submenu [nzTitle]="'o_tim_kiem' | translate" (mouseover)="objectChoosing.isShow = true" [(nzOpen)]="openMap.menu6"
        (nzOpenChange)="openHandler('menu6')">
        <!-- Sử dụng -->
        <div class="d-flex justify-content-between align-items-center">
          <p class="title m-0" style="line-height: 1.5">{{'su_dung' | translate}}</p>
          <nz-switch [(ngModel)]="staticdata.allow_search" (ngModelChange)="updateStaticData()"></nz-switch>
        </div>
        <ng-container *ngIf="staticdata.allow_search">
          <!-- Tìm kiếm -->
          <ul nz-menu nzMode="inline">
            <li class="pl-2" nz-submenu [nzTitle]="'dinh_dang_chu' | translate">
              <h3 class="text-center mb-1"><strong>{{'chu_nen' | translate}}</strong></h3>
              <!-- Nội dung chữ nền -->
              <div class="config-text" style="width: 100%">
                <mat-form-field style="width: 100%">
                  <mat-label> {{'noi_dung' | translate}}</mat-label>
                  <textarea matInput
                    [ngModel]="staticdata['placeholder_search_' + functionService.selectedLanguageCode] | vhLanguage : 'content' : objectChoosing.component"
                    (ngModelChange)="staticdata['placeholder_search_' + functionService.selectedLanguageCode] = $event"
                    (blur)="updateStaticData();"></textarea>
                </mat-form-field>
              </div>
              <!-- Màu chữ nền -->
              <div>
                <h3 class="text-center mb-1"><strong>{{'mau_chu_nen' | translate}}</strong></h3>
                <div class="d-flex justify-content-between align-items-center">
                  <span class="title w-50">{{'mau_chu_nen' | translate}}</span>
                  <input class="input-color w-50" type="button" [cpOKButton]="true"
                    [(colorPicker)]="class['select__search--placeholder']['color']"
                    [style.background]="class['select__search--placeholder']['color']"
                    (colorPickerClose)="updateClass()" [cpWidth]="'230px'"
                    [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength" [cpAddColorButton]="true"
                    [cpAddColorButtonText]="'them_mau' | translate" [cpPresetLabel]="'bang_mau_mau' | translate"
                    [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate"
                    [cpPresetColors]="themeService.themeColors"
                    (cpPresetColorsChange)="themeService.presetColorsChange($event)" />
                </div>
              </div>

              <h3 class="text-center mb-1"><strong>{{'chu_hien_thi' | translate}}</strong></h3>
              <div class="config-text" style="width: 100%">
                <mat-form-field style="width: 100%">
                  <mat-label> {{'noi_dung' | translate}}</mat-label>
                  <textarea matInput
                    [ngModel]="staticdata['placeholder_search_' + functionService.selectedLanguageCode] | vhLanguage : 'content' : objectChoosing.component"
                    (ngModelChange)="staticdata['placeholder_search_' + functionService.selectedLanguageCode] = $event"
                    (blur)="updateStaticData();"></textarea>
                </mat-form-field>
              </div>
              <app-text-format-config [objectChoosing]="objectChoosing" [isHideTextAlign]="true" [device]="device"
                [class]="class" [config]="config" [staticdata]="staticdata"
                [textContentClass]="class['select__search']" [textWrapperClass]="class['select__search']">
              </app-text-format-config>
              <!-- Khoảng cách chữ -->
              <app-letter-spacing-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
                [classLetterSpacing]="class['select__search']" (updateClass)="updateClass()">
              </app-letter-spacing-config>
            </li>
            <li class="pl-2" nz-submenu [nzTitle]="'khoang_dem' | translate">
              <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
                [classPadding]="class['select__search']" [paddingConfigs]="[
                      { type: 'top' },
                      { type: 'bottom' },
                      { type: 'left' },
                      { type: 'right' }
                      ]">
              </app-padding-config>
            </li>

            <li class="pl-2" nz-submenu [nzTitle]="'mau_nen' | translate">
              <div class="d-flex justify-content-between align-items-center">
                <span class="title w-50">{{'mau_nen' | translate}}</span>
                <input class="input-color w-50" type="button" [cpOKButton]="true"
                  [(colorPicker)]="class['select__search']['background-color']"
                  [style.background]="class['select__search']['background-color']"
                  (colorPickerClose)="updateClass()" [cpWidth]="'230px'"
                  [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength" [cpAddColorButton]="true"
                  [cpAddColorButtonText]="'them_mau' | translate" [cpPresetLabel]="'bang_mau_mau' | translate"
                  [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate"
                  [cpPresetColors]="themeService.themeColors"
                  (cpPresetColorsChange)="themeService.presetColorsChange($event)" />
              </div>
            </li>

            <li class="pl-2" nz-submenu [nzTitle]="'kieu_vien' | translate">
              <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
                [borderClass]="class['select__search']" [id_object]="objectChoosing._id">
              </app-borders-config>
            </li>

            <li class="pl-2" nz-submenu [nzTitle]="'bo_tron' | translate">
              <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
                [borderRadiusClass]="class['select__search']" [id_object]="objectChoosing._id">
              </app-borders-radius-config>
            </li>
          </ul>
        </ng-container>
      </li>
      

    </ul>
  </ng-container>

  <!-- CẤU HÌNH CHI TIẾT -->
  <div class="view-more" *ngIf="isViewAll">
    
  </div>
</div>